import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Success from "../../images/success.svg";
import Cross from "../../images/Icon-Cross.svg";
import Info from "../../images/info.svg";
import ErrorIcon from "../../images/error.svg";

const Alert = ({
  id,
  type,
  heading,
  message,
  alertClass,
  onClick,
  show,
  autoClose = false,
  time = 10000,
}) => {
  const [icon, setIcon] = useState(type);
  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        onClick(id);
      }, time);
    }
  }, []);
  useEffect(() => {
    switch (type.toLowerCase()) {
      case "success":
        setIcon(Success);
        break;
      case "info":
        setIcon(Info);
        break;
      case "error":
        setIcon(ErrorIcon);
        break;
      default:
        setIcon(Info);
    }
  }, [type]);

  return (
    <>
      {show && (
        <div className={`library-alert ${alertClass}`}>
          <div
            className={`alert ${
              type.toLowerCase() === "success" ? "customSuccess" : ""
            }${type.toLowerCase() === "info" ? "customInfo" : ""}${
              type.toLowerCase() === "error" ? "customError" : ""
            }`}
          >
            <div className="alert_border">
              <img src={icon} alt={icon} id="img" />

              <div className="alert_content">
                <div className="alert-heading">{heading}</div>
                <p>{message}</p>
              </div>
            </div>
            <button
              type="button"
              className="close"
              id="button"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => onClick(id)}
            >
              <img id="cross" src={Cross} alt={Cross} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};
Alert.prototype = {
  heading: PropTypes.string,
  alertClass: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
  type: PropTypes.string,
  message: PropTypes.string,
  id: PropTypes.number,
};

Alert.defaultProps = {
  heading: "",
  show: true,
  alertClass: "",
  type: "",
  message: "",
};

export default Alert;
